import { ListingsSearchAllFilters, ListingsSearchSideFilters } from '../types';

export function mapListingsSearchAllFiltersToSideFilters(
  allFilters: ListingsSearchAllFilters,
): ListingsSearchSideFilters {
  const sideFilters: ListingsSearchSideFilters = {
    searchCategories: allFilters.searchCategories,
    furnishings: allFilters.furnishings,
    hasInternet: allFilters.hasInternet,
    isBathroomPrivate: allFilters.isBathroomPrivate,
    isKitchenPrivate: allFilters.isKitchenPrivate,
    isToiletPrivate: allFilters.isToiletPrivate,
    availabilityPeriods: allFilters.availabilityPeriods,
    availableFrom: allFilters.availableFrom,
    suitableForNumberOfPersons: allFilters.suitableForNumberOfPersons,
    suitableForGenders: allFilters.suitableForGenders,
    suitableForAge: allFilters.suitableForAge,
    suitableForWorkStatuses: allFilters.suitableForWorkStatuses,
    isSmokingInsideAllowed: allFilters.isSmokingInsideAllowed,
    isPetsInsideAllowed: allFilters.isPetsInsideAllowed,
    roommateNumberMax: allFilters.roommateNumberMax,
    roommateGenders: allFilters.roommateGenders,
    ownerTypes: allFilters.ownerTypes,
    radius: allFilters.radius,
    maxRent: allFilters.maxRent,
    minSize: allFilters.minSize,
  };

  return sideFilters;
}
